var _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaunurLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 64,
    viewBox: "0 0 280 64",
    fill: "none",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Taunur") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#F2F3EB",
    strokeWidth: 7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 23V53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 53V30H60Q47 30 47 42Q47 53 60 53H73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 30V43Q91 53 103 53Q115 53 115 43V30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 53V30H146Q158 30 158 42V53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 30V43Q177 53 189 53Q201 53 201 43V30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 53V42Q220 30 233 30H238"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H40L34 16H2L8 8Z",
    fill: "#C6F36A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253 44H265L259 56H247L253 44Z",
    fill: "#C6F36A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaunurLogo);
export default __webpack_public_path__ + "static/media/taunur-logo.25a867b58c7d33fcd7d29448a0d92dda.svg";
export { ForwardRef as ReactComponent };